module.exports = __webpack_public_path__ + "static/media/crimson_hd.1a22944d.jpg";